// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取营销文章详情 GET /promotion-article/info */
export async function promotionArticleInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionArticleInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionArticleInfoResp>('/promotion-article/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
